var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{attrs:{"id":"salvamentoAutomatico"},on:{"mouseover":_vm.formatarHora}},[_c('v-tooltip',{attrs:{"bottom":""},scopedSlots:_vm._u([{key:"activator",fn:function(ref){
var on = ref.on;
return [_c('span',_vm._g({domProps:{"innerHTML":_vm._s(_vm.mensagem)}},on))]}}])},[_c('span',[_vm._v("Salvo "+_vm._s(_vm.dataAtualizada)+" atrás")])])],1)}
var staticRenderFns = []

export { render, staticRenderFns }